import { render, staticRenderFns } from "./LogManagement.vue?vue&type=template&id=2343f620&scoped=true"
import script from "./LogManagement.vue?vue&type=script&lang=js"
export * from "./LogManagement.vue?vue&type=script&lang=js"
import style0 from "./LogManagement.vue?vue&type=style&index=0&id=2343f620&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2343f620",
  null
  
)

export default component.exports